import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import FullscreenLayout from '@layouts/FullscreenLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const AddRecoveryMethodRoute = lazyWithRetries(() => import('./addRecoveryMethods'))
const VerifyRecoveryMethodRoute = lazyWithRetries(() => import('./verifyRecoveryMethod'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.addDesklessRecoveryMethod(),
    element: (
      <FullscreenLayout>
        <Suspense fallback={<RouteLoading />}>
          <AddRecoveryMethodRoute />
        </Suspense>
      </FullscreenLayout>
    ),
  },
  {
    path: AppPaths.tenant.verifyDesklessRecoveryMethod(),
    element: (
      <FullscreenLayout>
        <Suspense fallback={<RouteLoading />}>
          <VerifyRecoveryMethodRoute />
        </Suspense>
      </FullscreenLayout>
    ),
  },
]

export default routes
